import { $Qll, $Q } from './querySelector';

/**
 * Handles the button events of the addresses section, to show the edit and add forms
 */
if (window.location.href.includes('addresses')) {
  document.addEventListener('DOMContentLoaded', () => {
    const addresses = $Qll('.address');
    const newAddressForm = $Q('.address__add-form');

    // toggle the add new address form
    $Q('.add-new-address-button').addEventListener('click', () => {
      newAddressForm.classList.toggle('shown');
    });

    // hide the add new address form
    $Q('.close-add-address-form').addEventListener('click', () => {
      newAddressForm.classList.remove('shown');
    });

    addresses.forEach((address) => {
      // bind edit address clicks to expand the edit form for each address
      $Q('.edit-address-button', address).addEventListener('click', (e) => {
        const formId = e.target.dataset.controls;

        const form = $Q(`#${formId}`);
        form.classList.toggle('shown');

        $Q('.cancel-edit-form', form).addEventListener('click', () => {
          form.classList.remove('shown');
        });
      });
    });
  });
}
